<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/leaveoffice/leaveoffice',title:'离职交接'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item  label="被交接人">
                                <el-input
                                        v-model="formInline.leaveName"
                                        placeholder="请输入编码或名称"
                                        clearable>
                                </el-input>
                            </el-form-item>
                            <el-form-item  label="承接人">
                                <el-input
                                        v-model="formInline.handoverName"
                                        placeholder="请输入编码或名称"
                                        clearable>
                                </el-input>
                            </el-form-item>
                            <el-form-item  label=""></el-form-item>
                            <el-form-item>
                                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                                <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                                <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="leaveApply">
                                    离职申请
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        :data="tableData"
                        stripe
                        style="width: 100%"
                        border>
                    <el-table-column
                            type="index"
                            label="#"
                            fixed
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="leaveCode"
                            label="离职人编码"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="leaveName"
                            label="离职人名称"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="handoverCode"
                            label="交接人编码"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="handoverName"
                            label="交接人名称"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="离职提出时间"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="passdate"
                            label="审批通过时间"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="leaveExplain"
                            label="离职说明"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="handoverStatus"
                            label="交接状态"
                            width="100"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{scope.row.handoverStatus|dictname('leave_type')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="120">
                        <template slot-scope="scope">
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    @click="genzongLiuch(scope.row)">跟踪审批
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        components: {},
        data() {
            return {
                //查询属性
                formInline: {
                    leaveName: '',
                    handoverName: '',
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                //table列表
                tableData: [],
                instid: '',
                showhistory:false,
            }
        },
        created() {
            this.query();
        },
        methods: {
            genzongLiuch(v){
                this.instid = v.instid;
                this.showhistory = true;
            },
            query() {
                ss.leaveService.selectPage(this.formInline).then(rd=>{
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            resetData() {
                this.formInline.leaveName = '';
                this.formInline.handoverName = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.query();
            },
            leaveApply() {
                ss.leaveService.selectTask().then(rd=>{
                    if (rd.f == true) {
                        this.$router.push({
                            path: "/leaveoffice/leaveApply"
                        });
                    } else {
                        this.$msg.msge(rd.msg);
                    }
                })
            }
        }
    }
</script>
